import nodataEn from 'plugins/i18n/locales/component/templates/nodata.en.ts'
import editorEn from 'plugins/i18n/locales/component/elements/editor.en.ts'
import notificationsEn from 'plugins/i18n/locales/component/elements/notifications.en.ts'
import activityFeedEn from 'plugins/i18n/locales/component/modules/activityFeed/activityFeed.en.ts'
import profileEn from 'plugins/i18n/locales/component/modules/profile/profile.en.ts'
import propertymanagersEn from 'plugins/i18n/locales/component/modules/propertymanagers.en.ts'
import reportsEn from 'plugins/i18n/locales/component/modules/pendingRequest/reports/reports.en.ts'
import readConfirmationsEn from 'plugins/i18n/locales/component/modules/readConfirmations.en.ts'
import notesEn from 'plugins/i18n/locales/component/modules/notes/notes.en.ts'
import loginEn from 'plugins/i18n/locales/component/modules/login/login.en.ts'
import dashboardEn from 'plugins/i18n/locales/component/modules/dashboard/dashboard.en.ts'
import buildingsEn from 'plugins/i18n/locales/component/modules/buildings/buildings.en.ts'
import personsEn from 'plugins/i18n/locales/component/modules/persons/persons.en.ts'
import documentsEn from 'plugins/i18n/locales/component/modules/documents/documents.en.ts'
import craftsmanTasksEn from 'plugins/i18n/locales/component/modules/craftsmanTasks/craftsmanTasks.en.ts'
import reviewDocumentEn from 'plugins/i18n/locales/component/modules/reviewDocuments/reviewDocuments.en.ts'
import commentsEn from 'plugins/i18n/locales/component/modules/comments/comments.en.ts'
import accountsEn from 'plugins/i18n/locales/component/modules/accounts/accounts.en.ts'
import managementEn from 'plugins/i18n/locales/component/modules/management/management.en.ts'
import syncFailuresEn from 'plugins/i18n/locales/component/modules/management/syncFailures.en.ts'
import accessRejectionsEn from 'plugins/i18n/locales/component/modules/management/accessRejections.en.ts'
import tasksEn from 'plugins/i18n/locales/component/modules/tasks/tasks.en.ts'
import teamsEn from 'plugins/i18n/locales/component/modules/teams/teams.en.ts'
import rolepermissionEn from 'plugins/i18n/locales/component/modules/persons/rolepermission.en.ts'
import subscriptionsEn from 'plugins/i18n/locales/component/modules/subscriptions/subscriptions.en.ts'
import drawerEn from 'plugins/i18n/locales/component/elements/drawer.en.ts'
import faqsEn from 'plugins/i18n/locales/component/modules/faqs/faqs.en.ts'
import toastEn from 'plugins/i18n/toast.en.ts'
import consumptionEn from 'plugins/i18n/locales/component/modules/consumption.en.ts'
import unitsEn from 'plugins/i18n/locales/component/modules/units/units.en.ts'
import liaEn from 'plugins/i18n/locales/component/elements/lia.en.ts'
import cookieEn from 'plugins/i18n/locales/component/elements/cookie.en.ts'
import errorEn from 'plugins/i18n/locales/component/elements/error.en.ts'
import invoiceEn from 'plugins/i18n/locales/component/modules/buildings/invoice.en.ts'
import metersEn from 'plugins/i18n/locales/component/modules/buildings/meters.en.ts'
import updateDialogEn from 'plugins/i18n/locales/component/modules/updateDialog.en.ts'
import legacySyncBannerEn from 'plugins/i18n/locales/component/modules/legacySyncBanner.en.ts'
import datatableEn from 'plugins/i18n/locales/component/templates/datatable.en.ts'
import exportEn from 'plugins/i18n/locales/component/templates/export.en.ts'
import passwordConfirmationEn from 'plugins/i18n/locales/component/templates/passwordConfirmation.en.ts'
import sitePolicyEn from 'plugins/i18n/locales/component/modules/sitePolicy.en.ts'
import addressesEn from 'plugins/i18n/locales/component/modules/addresses/addresses.en.ts'
import baseImage from './baseImage'

const component = {
	...nodataEn,
	...editorEn,
	...notificationsEn,
	...activityFeedEn,
	...profileEn,
	...propertymanagersEn,
	...reportsEn,
	...readConfirmationsEn,
	...notesEn,
	...loginEn,
	...dashboardEn,
	...buildingsEn,
	...personsEn,
	...documentsEn,
	...craftsmanTasksEn,
	...reviewDocumentEn,
	...commentsEn,
	...accountsEn,
	...managementEn,
	...syncFailuresEn,
	...accessRejectionsEn,
	...tasksEn,
	...teamsEn,
	...rolepermissionEn,
	...subscriptionsEn,
	...drawerEn,
	...faqsEn,
	...toastEn,
	...unitsEn,
	...consumptionEn,
	...liaEn,
	...cookieEn,
	...errorEn,
	...invoiceEn,
	...metersEn,
	...updateDialogEn,
	...legacySyncBannerEn,
	...datatableEn,
	...exportEn,
	...passwordConfirmationEn,
	...sitePolicyEn,
	...addressesEn,
	locale: {
		name: 'Chose your language',
		language: 'Language',
		icon: 'fal fa-language',
		de: 'German',
		en: 'English',
	},
	theme: {
		name: 'Appearance',
		client: 'Property manager',
		icon: 'fas fa-palette',
		light: 'Light',
		dark: 'Dark',
		system: 'Device theme',
	},
	baseImage: baseImage.en,
}

export default component
